import React from 'react';
const Story = () => {
  return <section className="w-full bg-white py-16" data-id="element-262">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-263">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-[#8B4513] mb-12" data-id="element-264">
          🔥 La historia real que cambió todo
        </h2>
        <div className="bg-[#F5EBE0] p-8 rounded-lg shadow-lg" data-id="element-265">
          <h3 className="text-2xl font-bold text-[#8B4513] mb-4" data-id="element-266">
            El punto de quiebre de Claudia
          </h3>
          <div className="mb-6" data-id="element-267">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5JdkJVUffVeLCRjXeHcwQk/Lifestyle_1.png" alt="Claudia en la cocina" className="w-full h-auto rounded-lg shadow-md mx-auto" data-id="element-268" />
          </div>
          <p className="text-lg mb-4 text-[#5E4B3C]" data-id="element-269">
            Claudia quiso hacer algo especial. Una cena íntima, amigos, familia…
            Pero sus bocaditos pasaron desapercibidos.
          </p>
          <p className="text-lg mb-4 text-[#5E4B3C]" data-id="element-270">
            Nadie dijo nada. Hasta que alguien soltó:
          </p>
          <blockquote className="border-l-4 border-[#E25822] pl-4 italic my-6 text-xl text-[#8B4513]" data-id="element-271">
            "¿Eso fue todo? Pensé que sería algo más especial…"
          </blockquote>
          <p className="text-lg mb-4 text-[#5E4B3C]" data-id="element-272">
            Ese comentario le dolió más que cualquier crítica.
          </p>
          <p className="text-lg mb-4 text-[#5E4B3C]" data-id="element-273">
            Esa noche se prometió: <span className="font-bold" data-id="element-274">nunca más</span>.
          </p>
          <p className="text-lg mb-4 text-[#5E4B3C]" data-id="element-275">
            Desde entonces, Claudia dedicó semanas a estudiar, probar y
            perfeccionar recetas diseñadas para impactar. No para llenar. Para
            impresionar.
          </p>
          <p className="text-lg font-bold text-[#8B4513]" data-id="element-276">
            Y así nació el Combo Gourmet de más de 10 eBooks. Una colección
            secreta de más de 250 recetas que despiertan deseo visual, placer
            inmediato y orgullo absoluto.
          </p>
        </div>
      </div>
    </section>;
};
export default Story;